import hubLayout from 'styles/css/hubLayout.module.css';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { qrScan } from 'api/bridge';
import { encryptSHA256, maxLengthCheck } from 'api/api';
import { styled } from 'styled-components';
import Loading from 'components/common/Loading';
import { useModal } from 'components/common/ModalLayout';

const OtpContainer = styled.div`
  margin-top: 6rem;
`;
const OtpUl = styled.ul`
  display: flex;
  gap: 1rem;
  width: 100%;
  padding: 1rem;
  justify-content: space-between;
  align-items: center;
`;
const OtpLi = styled.li`
  display: inline-block;
  padding: 1.5rem 1rem;
  border: #1568dd 3px solid;
  font-size: 2rem;
  border-radius: 0.5rem;
  text-align: center;
  width: calc(100% / 4);
`;

function OtpRegister() {
  const navigate = useNavigate();
  const { showModal } = useModal();
  const [key, setKey] = useState<string>("");
  const [otp, setOtp] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  // useForm
  const { register, formState: { errors, isValid }, setValue } = useForm<any>({
    mode: 'all',
  });
  const handleChange = (event: any) => {
    const { value } = event.target;
    setKey(value);
  }
  // `qrScanner` 호출 => 완료시 qrCallback
  const qrScanner = () => {
    try {
      qrScan();
    } catch (error) {
      console.log(error)
    }
  };
  window.qrCallback = (response: any) => {
    try {
      const data = JSON.parse(response);
      const key = data.key;
      setValue('key', key, { shouldValidate: true });
      setKey(key);
    } catch (error) {
      showModal('alert', `일치하지 않는 형식입니다.(${response})`);
    }
  };

  // SHA-256 해시를 기반으로 OTP 생성
  function generateOTP() {
    const hash = encryptSHA256(key);
    const bytes = [
      parseInt(hash.substring(0, 2), 16),
      parseInt(hash.substring(2, 4), 16),
      parseInt(hash.substring(4, 6), 16),
      parseInt(hash.substring(6, 8), 16),
    ];
    const strOtp = bytes.map(byte => byte % 10).join('');
    setLoading(true);
    setTimeout(() => {
      setOtp(strOtp);
      setLoading(false);
    }, 500);
  }
  return (
    <>
      <div className={`${hubLayout.cnt_box}`}>
        <div className={`${hubLayout.acc__cnt}`}>
          <div className={`${hubLayout.sec_title}`}>
            <h2>매니저 OTP 생성</h2>
            <span onClick={() => navigate(-1)}>X</span>
          </div>
              <h2 className={`${hubLayout.cnt_title} ${hubLayout.tx_blue}`}>OTP Key 확인</h2>
              <div className={`${hubLayout.acc_item_info}`}>
                <dl>
                  <dt>OTP Key</dt>
                  <dd className={`${hubLayout.display_flex}`}>
                    <input type="text" className={`${errors.mac && hubLayout.border_red}`} value={key} maxLength={6}
                      {...register(`key`, {
                        required: true,
                        pattern : /^[A-Z0-9]{6}$/,
                        onChange: (e:any) => {
                          handleChange(e);
                          maxLengthCheck(e);
                        }
                      })}
                    />
                    <div className={`${hubLayout.width_100}`}>
                      <button type="button" className={`${hubLayout.btn} ${hubLayout.medium} ${hubLayout.pink}`} onClick={qrScanner}>QR</button>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dd style={{ marginLeft: '30px' }}>
                    <p>알파벳(대문자) + 숫자 조합 6글자</p>
                  </dd>
                </dl>
                <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.blue}`} onClick={generateOTP} disabled={!isValid}>생성</button>
              </div>
              {loading ? <Loading />
              : otp && 
                <OtpContainer>
                  <OtpUl>
                    <OtpLi>{otp.slice(0,1)}</OtpLi>
                    <OtpLi>{otp.slice(1,2)}</OtpLi>
                    <OtpLi>{otp.slice(2,3)}</OtpLi>
                    <OtpLi>{otp.slice(3,4)}</OtpLi>
                  </OtpUl>
                </OtpContainer>
              }
        </div>
        <div className={`${hubLayout.btn_group} ${hubLayout.fixed_bottom_title} ${hubLayout.back_white}`}>
          <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.pink}`} onClick={() => navigate(-1)}>돌아가기</button>
        </div>
      </div>
    </>
  )
}

export default OtpRegister;